import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledAboutSection = styled.section`
  align-items: center;
  max-width: 900px;

  .inner {
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-gap: 50px;

    @media (max-width: 768px) {
      display: block;
    }
  }
`;
const StyledText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  ul.skills-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    display: grid;
    grid-template-columns: repeat(3, minmax(200px, 500px));
    grid-gap: 0 100px;
    padding: 0;
    margin: 20px 0 0 0;
    overflow: hidden;
    list-style: none;

    li {
      align-items: center;
      position: relative;
      margin-bottom: 10px;
      padding-left: 20px;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        align-items: center;
        content: "▹";
        position: absolute;
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;

const Skills = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  const progSkills = ['Python', 'C/C++', 'Java', 'SQL', 'MATLAB'];
  const tech = [
    'PyTorch',
    'Deep Learning',
    'Signal Processing',
    'Natural Language Processing',
    'Retrieval Augmented Generation',
  ];
  const others = ['AWS', 'Kafka', 'Kubernetes', 'MongoDB', 'Unity', 'LaTeX'];

  return (
    <StyledAboutSection id="skills" ref={revealContainer}>
      <h2 className="numbered-heading">What am I good at?</h2>

      <div className="inner">
        <StyledText>
          <h3>Languages</h3>
          <ul className="skills-list">
            {progSkills &&
              progSkills.map((skill, i) => <li key={i}>{skill}</li>)}
          </ul>
          <br />
          <h3>ML &amp; Research</h3>
          <ul className="skills-list">
            {tech && tech.map((skill, i) => <li key={i}>{skill}</li>)}
          </ul>
          <h3>Tools &amp; Systems</h3>
          <ul className="skills-list">
            {others && others.map((skill, i) => <li key={i}>{skill}</li>)}
          </ul>
        </StyledText>
      </div>
    </StyledAboutSection>
  );
};

export default Skills;
